import React from 'react'
import { eachDay } from 'date-fns'

import uiStore from '../../../utils/UIStore'

import FormHomePage from '../../FormHomePage'

import ButtonTextWithIcon from '../ButtonTextWithIcon'
import BookingResponseMessage from '../BookingResponseMessage'

import {
  ButtonWrapper,
  BookButton,
  ButtonSupportText,
  ScrollButtonWrapper,
  ScrollBookButton,
  ScrollButtonSupportText
} from './styledComponents'

class MobileBookNowButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: null, // eslint-disable-line
      isVisible: false
    }
  }

  handleScroll = () => {
    if (window.pageYOffset > window.innerHeight) {
      this.setState({ isVisible: true })
    } else {
      this.setState({ isVisible: false })
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

  captureBookingResponseModalRef = ref => {
    if (ref) {
      this.bookingResponseModalRef = ref
    }
  }

  closeLightBoxCallBack = () => {
    if (this.formMobileRef) {
      this.formMobileRef.resetForm()
    }
  }

  closeMobileForm = () => {
    if (this.formMobileRef) {
      this.formMobileRef.closeModal()
    }
  }

  onFormSubmitSuccess = formData => {
    this.setFormDataState(formData)
    // open booking response modal
    this.openBookingResponseModal()
  }

  openBookingResponseModal = () => {
    if (this.bookingResponseModalRef) {
      this.bookingResponseModalRef.openModal()
    }
  }

  captureBookingResponseModalRef = ref => {
    if (ref) {
      this.bookingResponseModalRef = ref
    }
  }

  captureFormMobileRef = ref => {
    if (ref) {
      this.formMobileRef = ref
      uiStore.captureFormMobileRef(ref)
    }
  }

  captureSBFormModalRef = ref => {
    if (ref) {
      this.sbFormModalRef = ref
      this.captureFormMobileRef(ref)
      uiStore.setMobileSBFormModalRef(ref)
    }
  }

  closeLightBoxCallBack = () => {
    if (this.formDesktopRef) {
      this.formDesktopRef.resetForm()
    }
    if (this.formMobileRef) {
      this.formMobileRef.resetForm()
    }
  }

  closeMobileForm = () => {
    if (this.formMobileRef) {
      this.formMobileRef.closeModal()
    }
  }

  onClickBookMySlot = () => {
    console.log('entered')
    if (this.sbFormModalRef) {
      this.sbFormModalRef.openModal()
    }
  }

  setFormDataState = formData => {
    this.setState({
      formData // eslint-disable-line
    })
  }

  onFormSubmitSuccess = formData => {
    this.setFormDataState(formData)
    // open booking response modal
    this.openBookingResponseModal()
  }

  getConvertedDate = date => (date ? new Date(date) : null)

  render() {
    const {
      termsAndConditionsData,
      slotIdPrefix,
      arcadeFormMauticID,
      arcadeCity,
      pagePrefix,
      amanoraSectionDetails,
      bookingResponseData,
      priceCardsData,
      id
    } = this.props
    const {
      arcadeClosingDate,
      arcadeClosingEndDate,
      arcadeClosedDatesList
    } = bookingResponseData
    const { formData, isVisible } = this.state
    let excludeDates = arcadeClosedDatesList
      ? eachDay(
          this.getConvertedDate(arcadeClosingDate),
          this.getConvertedDate(arcadeClosingEndDate)
        ).concat(
          arcadeClosedDatesList
            .split(',')
            .map(date => this.getConvertedDate(date))
        )
      : eachDay(
          this.getConvertedDate(arcadeClosingDate),
          this.getConvertedDate(arcadeClosingEndDate)
        )
    return (
      <div>
        <ButtonWrapper onClick={this.onClickBookMySlot} id={id}>
          <BookButton>
            <ButtonTextWithIcon text="BOOK NOW" />
          </BookButton>
          <ButtonSupportText>Pay when you visit the arcade.</ButtonSupportText>
        </ButtonWrapper>
        <ScrollButtonWrapper
          isVisible={isVisible}
          onClick={this.onClickBookMySlot}
          id={id}
        >
          <ScrollBookButton>
            <ButtonTextWithIcon text="BOOK NOW" />
            <ScrollButtonSupportText>
              Pay when you visit the arcade.
            </ScrollButtonSupportText>
          </ScrollBookButton>
        </ScrollButtonWrapper>
        <FormHomePage
          ref={this.captureSBFormModalRef}
          onFormSubmitSuccess={this.onFormSubmitSuccess}
          termsAndConditionsData={termsAndConditionsData}
          slotIdPrefix={slotIdPrefix}
          arcadeFormMauticID={arcadeFormMauticID}
          arcadeCity={arcadeCity}
          pagePrefix={pagePrefix}
          excludeDates={excludeDates}
          priceCardsData={priceCardsData}
        />
        <BookingResponseMessage
          amanoraSectionDetails={amanoraSectionDetails}
          bookingResponseData={bookingResponseData}
          bookingInfo={formData}
          ref={this.captureBookingResponseModalRef}
          closeLightBoxCallBack={this.closeLightBoxCallBack}
          closeMobileForm={this.closeMobileForm}
          pagePrefix={pagePrefix}
        />
      </div>
    )
  }
}

export default MobileBookNowButton



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MobileBookNowButton/index.js